export default "__VITE_ASSET__DUGaod6G__"